// Standard library imports
import React, { useEffect, useState } from 'react';
// External library imports
import moment from 'moment';
import { get as lodashGet } from 'lodash';

// Internal module imports
import { useLoader, useQueryParamWithDefault } from '../../../../hooks';
import { DropdownComponent } from '../../../../components/Inputs/Input';
import Typography from '../../../../components/Typography/Typography';
import Table from '../../../../components/Table/Table';
import DatePicker from '../../../../components/Inputs/DatePicker/DatePicker';
import { AdminBiddingService } from '../../../../services/BiddingService/Admin/BiddingService';
import { DateParam, StringParam } from 'use-query-params';
import FilterBarClasses from '../../../../styles/Filterbar.module.css';
import bidClasses from '../Bidding.module.css';

const TotalCapacity = ({ market, cId }) => {
    const [startLoader, stopLoader] = useLoader();
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useQueryParamWithDefault('customer', StringParam, '', cId);
    const [date, setDate] = useQueryParamWithDefault('date', DateParam, moment().toDate(), cId);
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchMarketEnabledInstances();
    }, []);

    useEffect(() => {
        if (selectedCustomer) fetchTotalCapacity();
    }, [date, selectedCustomer]);

    const handleError = (error) => {
        console.error(error);
    };

    const fetchMarketEnabledInstances = () => {
        AdminBiddingService.GetMarketEnabledCusLicenseIns(market, startLoader, groupSuccess, handleError, stopLoader);
    };

    const groupSuccess = ({ data }) => {
        const customerOptions = [];
        for (let cusId in data?.data) {
            customerOptions.push({
                value: cusId,
                label: lodashGet(data, ['data', cusId, 'name']),
            });
        }
        setCustomers(customerOptions);
        setSelectedCustomer(lodashGet(customerOptions, [0, 'value']));
    };

    const fetchTotalCapacity = () => {
        const params = {
            customerId: selectedCustomer,
            market: market,
            date: moment(date).format('YYYY-MM-DD'),
        };
        AdminBiddingService.TotalBidCapacity(params, startLoader, handleFetchSuccess, handleError, stopLoader);
    };

    const handleFetchSuccess = ({ data }) => {
        setData(data?.data || []);
    };

    return (
        <div>
            <div className={FilterBarClasses.ParentWrapper} style={{ alignItems: 'center' }}>
                <div className={FilterBarClasses.Left}>
                    <div className={FilterBarClasses.Filter}>
                        <label>Customer</label>
                        <div className={bidClasses.DropdownContainer}>
                            <DropdownComponent
                                defaultValue={{ value: selectedCustomer }}
                                options={customers}
                                onChange={(e) => {
                                    setSelectedCustomer(e.value);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={FilterBarClasses.Right} style={{ alignItems: 'center' }}>
                    <div className={FilterBarClasses.Filter}>
                        <label>Date</label>
                        <DatePicker date={date} setDate={setDate} showArrow={true} disableFutureDate={false} />
                    </div>
                    <button className="btn-primary" style={{ width: 'auto' }} onClick={fetchTotalCapacity}>
                        Submit
                    </button>
                </div>
            </div>

            <div className={bidClasses.MainContainer}>
                <div className={bidClasses.TableHeader}>
                    <div>
                        <Typography content={'Total Capacity'} />
                        <div className={bidClasses.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={data.length} />
                            </span>
                        </div>
                    </div>
                </div>
                <Table head={['Slot', 'Hour', 'Capacity (MW)']} keys={['slot', 'hour', 'capacity']} data={data} />
            </div>
        </div>
    );
};

export default TotalCapacity;
